import { render, staticRenderFns } from "./index.vue?vue&type=template&id=5bc87158&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=5bc87158&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bc87158",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\App_php\\cqjtdx\\cqjtdx_student\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5bc87158')) {
      api.createRecord('5bc87158', component.options)
    } else {
      api.reload('5bc87158', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=5bc87158&scoped=true", function () {
      api.rerender('5bc87158', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/business/realTest/index.vue"
export default component.exports